import { InventoryImportRepository } from '@lib/api/repository/inventory-import/inventory-import.repository';
import { DurableInventoryBatchInput, InventoryImportBatchReceipt, InventoryImportMatch, InventoryImportRow } from '@lib/types';

import { Requester } from '../clients';

export default class InventoryImportAPI implements InventoryImportRepository {
  async saveImportBatch(input: DurableInventoryBatchInput) {
    return (await Requester.post<InventoryImportBatchReceipt>('/marketplace/inventory/import/batch', { body: input, customTimeout: 180_000 })).data;
  }

  async listImportBatches(operationId: string, signal?: AbortSignal) {
    return (await Requester.get<InventoryImportBatchReceipt[]>(`/marketplace/inventory/import/operations/${encodeURIComponent(operationId)}`, { signal })).data;
  }

  async matchImport(gameCode: string, rows: InventoryImportRow[]) {
    return (
      await Requester.post<InventoryImportMatch[]>(
        '/marketplace/inventory/import/match',
        { body: { gameCode, rows }, customTimeout: 30_000 },
      )
    ).data;
  }
}
